// LivestreamDetailControlButtons.js
import { connect } from 'react-redux';

import LivestreamDetailControlButtons from '../component/LivestreamDetailControlButtons.jsx';

import getOperationData from '../selector/getOperationData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getUserData from '../selector/getUserData.js';
import getShareTemplates from '../selector/getShareTemplates.js';
import getModalData from '../selector/getModalData.js';
import getPrivateShowStatus from '../selector/getPrivateShowStatus.js';

import setLiveStreamPanel from '../action/setLiveStreamPanel.js';
import setPlayerData from '../action/setPlayerData.js';
import toggleModal from '../action/toggleModal.js';
import addModal from '../action/addModal.js';
import { ExclusivePrivateStatus } from '../resource/liveStreamConstants.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

import { ShareType } from '../hook/useShortShareLink.js';

const mapStateToProps = (state, { userId, streamId }) => {
  const streamStatus = getLiveStreamData(state, [streamId], 'status');
  const hasStreamToken = !!(
    getOperationData(
      state,
      ['liveStream', 'paid', streamId],
      'byteplusToken'
    ) ||
    getOperationData(state, ['liveStream', 'paid', streamId], 'streamToken')
  );

  const exclusivePrivateStatus = getLiveStreamData(
    state,
    [streamId, 'exclusivePrivate'],
    'status'
  );
  const isExclusivePrivatePerforming =
    ExclusivePrivateStatus.PERFORMING === exclusivePrivateStatus;
  const needStreamTokenForExclusivePrivatePerforming =
    isExclusivePrivatePerforming && !hasStreamToken;

  const isKaraokeDeviceOnline = !!getLiveStreamData(
    state,
    [streamId],
    'device'
  );

  return {
    sessionId: getLiveStreamData(state, [streamId], 'sessionId'),
    username: getUserData(state, userId, 'username'),
    streamStatus,
    isMuted: getOperationData(state, ['player'], 'isMuted'),
    isAsideExpanded: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isAsideExpanded'
    ),
    isTriggerPrivatePanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isTriggerPrivatePanelOpen'
    ),
    isGiftPanelOpen: getOperationData(
      state,
      ['liveStream', 'panel'],
      'isGiftPanelOpen'
    ),
    hasStreamToken,
    needStreamTokenForExclusivePrivatePerforming,
    toyCommandHintOpenedTimestamp: getOperationData(
      state,
      ['liveStream'],
      'toyCommandHintOpenedTimestamp'
    ),
    privateShowStatus: getPrivateShowStatus(state, streamId),
    isKaraokeDeviceOnline,
    shareButtonTemplates: getShareTemplates(
      state,
      ShareType.LIVESTREAM,
      isKaraokeDeviceOnline
    ),
    isToyCommandModalOpen: ['display', 'opening'].includes(
      getModalData(state, 'LiveStreamKaraokeModal', 'status')
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setMuted: data => dispatch(setPlayerData(data)),
    setAsideExpended: ({ isAsideExpanded }) =>
      dispatch(setLiveStreamPanel({ isAsideExpanded })),
    openModal: ({ id }) =>
      dispatch(
        addModal({ id, isHigherThanAll: true, transitionStatus: 'coming' })
      ),
    toggleModal: data => dispatch(toggleModal(data)),
    toggleTriggerPrivatePanel: ({ isTriggerPrivatePanelOpen }) =>
      dispatch(
        setLiveStreamPanel({
          isTriggerPrivatePanelOpen,
          // when open private panel, ensure sidebar is expanded
          ...(isTriggerPrivatePanelOpen && { isAsideExpanded: true }),
        })
      ),
    setToyCommandHintOpenedTimestamp: ({ toyCommandHintOpenedTimestamp }) =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream'],
          data: {
            toyCommandHintOpenedTimestamp,
          },
        },
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LivestreamDetailControlButtons);
